import AppConstants from 'constants/AppConstants';

export function setCheckoutStatus(title: string, subtitle?: string) {
  return {
    type: AppConstants.CHECKOUT_SET_STATUS,
    payload: {
      title,
      subtitle,
    },
  };
}
